<!--
 * @Author: klein
 * @Date: 2021-12-13 14:37:23
 * @Description:
 * @LastEditors: Klein
 * @LastEditTime: 2022-01-11 17:25:46
 * @FilePath: \planApp\src\components\Channel\Manage.vue
-->
<template>
  <div
    id="manage-sub"
    v-loading="loading">
    <!-- <div class="title">
      Manage Subscriptions
    </div> -->
    <div
      class="manage-con"
      v-if="!showTotalControl">
      <div class="card-wrap">
        <div class="card-top">
          <!-- <div class="sub-name" v-if="planDetail">{{ planDetail.name }}</div> -->
          <div
            class="sub-name"
            v-if="planDetail">Unlimited</div>
          <div
            class="cancle-sub"
            @click="confirmCancelSub"
            v-if="subscription && subscription.status != 2">Subscribed</div>
        </div>

        <div
          class="sub-date"
          v-if="tryOut">Expiration date: {{ expirationDate | transDateAndTime(3) }}</div>
        <div
          class="manage-pay"
          @click="payMent">
          <div>Manage Payment</div>
          <div class="icon"><i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
      <div class="edit-plan">
        <div class="edit-left">
          <div class="plan-total">
            Total no. of Channels:
          </div>
          <div class="plan-price">
            ${{ price }} /per channel per {{ cycle }}
          </div>
        </div>
        <div class="edit-right">
          <div class="current">{{initsubnums}}</div>
          <div class="next">{{pretreatmentQuantity}} for next billing date</div>
        </div>
      </div>
      <!-- 如果有下个月有更改 -->
      <div
        class="next-diff"
        v-if="diffQuantity > 0">
        You have previously modified your subscription so you will lose access to <span style="color:#E56464">{{diffQuantity}}</span> channel(s) on <span style="color:#E56464">{{BILLING_DATE}}</span>
      </div>
      <div class="card-footer">
        <el-button @click="closeIframe">Cancel</el-button>
        <!-- <el-button class="confirm-box" :loading="confirmLoading" :disabled="subnums == initsubnums" @click="confirmEdit">{{ confirmText }}</el-button>
        <div class="tools-box">Cancel</div> -->
        <el-button
          class="confirm-box"
          @click="adjustSubscription">Adjust Subscription</el-button>
      </div>
    </div>
    <TotalControl
      v-else
      :price="price"
      :cycle="cycle"
      :initsubnums="initsubnums"
      :tryOut="tryOut"
      :pretreatmentQuantity="pretreatmentQuantity"
      @goBack="cancelControl"
      @confirm="handleTotal"
    ></TotalControl>
    <manage-dialog
      v-if="manageDialog"
      :type="dialogType"
      :diffPrice="diffPrice"
      :price="price"
      :cycle="cycle"
      :BILLING_DATE="BILLING_DATE"
      :quantityParams="quantityParams"
      @confirm="dialogConfirm"
      @cancel="dialogCancel">
    </manage-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      width="360px"
      top="calc(15vh + 120px)"
      :modal="true"
      custom-class="free-dialog"
      append-to-body
    >
      <img
        src="@/assets/svg/allright.svg"
        alt="">
      <div
        class="start"
        v-if="planIsPostPay">POST PAY COMPLETE</div>
      <div
        class="start"
        v-else>Your Subscription has been Modified</div>
      <br />

      <div
        class="info"
        v-if="planIsPostPay">Thank you, We will follow-up centralized deduction. You can start use it now.</div>
      <div
        class="info"
        v-else>Thank you! Your subscription has been successfully modified and the changes have been applied to your account.</div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="handleCloseIframe">Done</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Message, MessageBox } from 'element-ui'
import { handleNewSub, cancelSub, handlecustomerPortal, checkReduce, queryPrice, checkoutAddon } from '../../common/checkuser'

import ManageDialog from './ManageDialog.vue'
import TotalControl from './TotalControl.vue'
export default {
  name: 'Manage',
  components: {
    ManageDialog,
    TotalControl
  },
  props: {
    planDetail: {
      type: Object,
      default () {
        return {}
      }
    },
    subscription: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      subnums: 0,
      initsubnums: 0,
      loading: false,
      manageDialog: false,
      dialogType: '', // cancel reduce manage
      diffPrice: '0', // edit subs
      price: 0, // 价格
      planIsPostPay: false,
      dialogVisible: false,
      confirmLoading: false,
      havePretreatment: false, // 是否有 'pretreatmentChargeItems'
      pretreatmentQuantity: 0, // 下个月的 quantity
      diffQuantity: 0, // 当前订阅数和下个月对比
      BILLING_DATE: null, // 下次收费周期
      showTotalControl: false, // 是否展示total
      tryOut: false, // 是否是 试用
      quantityParams: {}
    }
  },
  mounted () {
    this.initData(true)
  },
  methods: {
    initData (init) {
      if (this.subscription.status != 2) {
        this.tryOut = this.subscription.status == 3
        this.initsubnums = this.subscription.chargeItems.length > 0 ? this.subscription.chargeItems[0].quantity : 1
        this.BILLING_DATE = this.$options.filters.transDateAndTime(this.subscription.duePaymentTime)
        const pretreatmentChargeItems = this.subscription.pretreatmentChargeItems
        if (pretreatmentChargeItems) {
          this.pretreatmentQuantity = pretreatmentChargeItems[0].quantity
          this.diffQuantity = this.initsubnums - this.pretreatmentQuantity
          this.havePretreatment = true
          // 如果下个月的比这个月的少 并且距离收费周期只有三天
          if (init && this.diffQuantity > 0 && this.subscription.duePaymentTime - new Date().getTime() <= 3 * 24 * 60 * 60 * 1000) {
            const message = `You have previously modified your subscription so you will lose access to <span style="color:#E56464">${this.diffQuantity}</span> channel(s) on <span style="color:#E56464">${this.BILLING_DATE}</span>.`
            MessageBox.confirm(message, 'Warning', {
              cancelButtonText: 'Got it',
              confirmButtonText: 'Adjust Subscription',
              type: 'warning',
              customClass: 'total-warn',
              dangerouslyUseHTMLString: true
            }).then(() => {
              this.adjustSubscription()
            }).catch()
          }
        } else {
          this.pretreatmentQuantity = this.initsubnums
          this.diffQuantity = this.initsubnums - this.pretreatmentQuantity
        }
      } else {
        this.initsubnums = 0
      }
      this.subnums = this.initsubnums
      this.handleQueryPrice()
    },
    // 去修改订阅
    adjustSubscription () {
      this.$emit('titlechange', '')
      this.showTotalControl = true
    },
    // 取消修改订阅
    cancelControl () {
      this.$emit('titlechange', 'Manage Subscriptions')
      this.showTotalControl = false
    },
    // 关掉整个弹窗
    handleCloseIframe () {
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    },
    // 计算周期
    handlecycle (cycle) {
      return cycle === 1 ? 'Week' : cycle === 2 ? 'month' : cycle === 3 ? 'Year' : ''
    },
    // 处理control total的返回值
    handleTotal (params) {
      console.log(params)
      const { initsubnums, pretreatmentQuantity } = params

      if (initsubnums == this.initsubnums && pretreatmentQuantity != this.pretreatmentQuantity) {
        // next改变 current不变
        this.changeNext(pretreatmentQuantity)
      } else {
        // current改变
        this.increaseSubscription(initsubnums, pretreatmentQuantity)
      }

      // if (initsubnums == this.initsubnums) { // current 没有改变
      //   if (pretreatmentQuantity !== this.pretreatmentQuantity) { // next改变
      //     console.log('current 没有改变 next改变');
      //   }
      // }else if (initsubnums == pretreatmentQuantity) { // 只增加current  next跟着变化的
      //   this.increaseSubscription(initsubnums)
      // }else { // current加 next加或者减
      //   console.log('current加 next加或者减');
      // }
    },
    changeNext (pretreatmentQuantity) {
      this.dialogType = 'manage'
      this.quantityParams = { pretreatmentQuantity, changeCurrent: false }
      this.manageDialog = true
    },
    // 增加当前订阅
    increaseSubscription (initsubnums, pretreatmentQuantity) {
      const key = this.planDetail.chargeItems[0].addonId
      const chargeItems = {
        [key]: initsubnums
      }
      const params = {
        customerId: this.emailid,
        product: 'Tvuchannel',
        planId: this.subscription.planId,
        proportionCalculation: true,
        chargeItems: JSON.stringify(chargeItems)
      }
      queryPrice(params).then(result => {
        const price = result.data.previewCustomSubscription.price / 100
        this.diffPrice = `+$${price}`
        this.dialogType = 'manage'
        this.quantityParams = { initsubnums, pretreatmentQuantity, changeCurrent: true }
        this.manageDialog = true
      })
    },
    // 确认修改
    confirmEdit () {
      if (!this.subnums) return false
      this.confirmLoading = true
      // 如果是减少订阅 就去check 一下 订阅数是否小于channel数 弹窗提示
      this.handleCheckReduce().then((res) => {
        this.dialogType = res ? 'manage' : 'reduce'
        if (res) {
          const diff = this.subnums - this.initsubnums
          if (diff > 0) {
            const key = this.planDetail.chargeItems[0].addonId
            const chargeItems = {
              [key]: this.subnums
            }
            const params = {
              customerId: this.emailid,
              product: 'Tvuchannel',
              planId: this.subscription.planId,
              proportionCalculation: true,
              chargeItems: JSON.stringify(chargeItems)
            }
            queryPrice(params).then(result => {
              const price = result.data.previewCustomSubscription.price / 100
              this.diffPrice = this.subnums > this.initsubnums ? `+ $${price}` : `- $${price}`
              this.manageDialog = true
            })
          } else {
            const price = Math.abs(diff) * this.price
            this.diffPrice = this.subnums > this.initsubnums ? `+ $${price}` : `- $${price}`
            this.manageDialog = true
          }
          // 2022.1.17 取消使用接口查询价格
          // 2022.1.18 增加掉接口，减少不用调
          // this.diffPrice =
          // queryPrice(params).then(result => {
          //   const price = result.data.previewCustomSubscription.price / 100

          // })
        } else {
          this.manageDialog = true
        }
        this.confirmLoading = false
      })
    },
    // 修改当前current
    handleEditSub (initsubnums, callback) {
      const key = this.planDetail.chargeItems[0].addonId
      const chargeItems = {
        [key]: Number(initsubnums)
      }
      const params = {
        customerId: this.emailid,
        product: 'Tvuchannel',
        planId: this.planDetail.id,
        description: `${this.planDetail.name} ${this.emailid} checkoutSubscription`,
        chargeItems: JSON.stringify(chargeItems)
      }
      this.loading = true
      handleNewSub(params, this).then(res => {
        console.log(res)
        if (callback) {
          callback()
        } else {
          this.dialogVisible = true
          if (res.info == 'NO-CARD') {
            this.manageDialog = false
          } else if (res.info == 'POST-PAY') {
            this.planIsPostPay = true
          }
          this.loading = false
          this.$emit('loadData')
          this.cancelControl()
        }
      }).catch(err => {
        this.loading = false
        if (err.type != 'NO-CARD') {
          Message.error({
            message: err.info,
            duration: 5000
          })
        }
        if (err.type == 'REDIRECT') {
          // 跳到第三方页面， 添加监听页面切回来
          this.handlePayRedirect(callback)
        }
      })
    },
    handleEditNextSub (pretreatmentQuantity) {
      this.loading = true
      const key = this.planDetail.chargeItems[0].addonId
      const chargeItems = {
        [key]: Number(pretreatmentQuantity)
      }
      const params = {
        customerId: this.emailid,
        product: 'Tvuchannel',
        planId: this.planDetail.id,
        chargeItems: JSON.stringify(chargeItems)
      }
      checkoutAddon(params).then(({ data }) => {
        this.loading = false
        if (data.checkoutAddon) {
          this.$emit('loadData')
          this.cancelControl()
        } else {
          Message.error('checkoutAddon error')
        }
        this.cancelControl()
        this.dialogVisible = true
      })
    },
    handlePayRedirect (callback) {
      // 只需要监听一次
      const _this = this
      function visibilitychange () {
        if (!window.document.hidden) {
          console.log('visibilitychange')

          if (callback) {
            callback()
          } else {
            _this.cancelControl()
            _this.$emit('loadData')
          }
          window.document.removeEventListener('visibilitychange', visibilitychange)
        }
      }
      window.document.addEventListener('visibilitychange', visibilitychange)
    },
    // 点击取消
    confirmCancelSub () {
      this.manageDialog = true
      this.dialogType = 'cancel'
      // this.handleCancelSub()
    },
    // cancel sub
    handleCancelSub () {
      const params = {
        product: 'Tvuchannel',
        planId: this.planDetail.id
      }
      this.loading = true
      cancelSub(params).then((res) => {
        this.loading = false
        if (!res.data.cancelSubscription) {
          this.manageDialog = true
          this.dialogType = 'cancel'
        }
        this.$emit('loadData')
      }).catch(() => {
        this.loading = false
        this.$emit('loadData')
      })
    },
    // 弹窗里的confirm
    dialogConfirm (params) {
      const { type, quantityParams } = params
      if (type == 'manage') {
        // this.handleEditSub()
        const { initsubnums, pretreatmentQuantity, changeCurrent } = quantityParams
        if (!changeCurrent) {
          // 只用修改下个月
          console.log('只用修改下个月')
          this.handleEditNextSub(pretreatmentQuantity)
        } else if (initsubnums == pretreatmentQuantity) {
          // 只用修改当前月
          console.log('只用修改当前月')
          this.handleEditSub(initsubnums)
        } else {
          // 先修改当前月 再修改下个月
          console.log('先修改当前月 再修改下个月')
          this.handleEditSub(initsubnums, () => {
            if (pretreatmentQuantity != this.pretreatmentQuantity) {
              this.handleEditNextSub(pretreatmentQuantity)
            }
          })
        }
      } else if (type == 'cancel') {
        this.handleCancelSub()
      } else if (type == 'reduce') {
        this.manageDialog = false
        this.$nextTick(() => {
          this.manageDialog = true
          this.dialogType = 'manage'
        })
        return
      }
      this.manageDialog = false
      this.dialogType = ''
    },
    // 关闭弹窗
    dialogCancel () {
      this.manageDialog = false
      this.dialogType = ''
    },
    // 降级的时候去check 一下
    handleCheckReduce () {
      return new Promise((resolve) => {
        const key = this.planDetail.chargeItems[0].addonId
        const chargeItems = {
          [key]: this.subnums
        }
        const params = {
          customerId: this.emailid,
          chargeItems: JSON.stringify(chargeItems)
        }
        checkReduce(params).then(res => {
          resolve(res.data.checkChannel)
        })
      })
    },
    // 打开 管理卡的窗口
    payMent () {
      const params = {
        customerId: this.emailid,
        product: 'Tvuchannel'
      }
      handlecustomerPortal(params)
    },
    // 查询价格
    handleQueryPrice () {
      const params = {
        customerId: this.emailid,
        product: 'Tvuchannel',
        planId: this.subscription.planId
      }
      queryPrice(params).then(res => {
        this.price = res.data.previewCustomSubscription.price / 100
      })
    },
    // 点击cancel
    closeIframe () {
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    }
  },
  computed: {
    ...mapState({
      emailid: state => state.userInfo.email
    }),
    expirationDate () {
      if (!this.subscription) return ''
      return Number(this.subscription.effectiveTime) + this.subscription.trialTime * 1000
    },
    confirmText () {
      return this.subscription && this.subscription.status != 2 ? 'Confirm' : 'Subscribe'
    },
    cycle () {
      return this.handlecycle(this.planDetail.chargeCycle)
    }
  },
  filters: {
    transDateAndTime (value, type) {
      value = Number(value)
      if (!value || value >= 9999999999999) return '---'
      let oDate = new Date(value)
      let oYear = oDate.getFullYear()
      let oMonth = oDate.getMonth() + 1
      let oDay = oDate.getDate()
      let oHour = oDate.getHours()
      let oMin = oDate.getMinutes()
      let oSen = oDate.getSeconds()
      let oMil = oDate.getMilliseconds()
      oHour = oHour <= 9 ? '0' + oHour : oHour
      oMin = oMin <= 9 ? '0' + oMin : oMin
      oSen = oSen <= 9 ? '0' + oSen : oSen
      oMil = oMil <= 99 ? (oMil = oMil <= 9 ? '00' + oMil : '0' + oMil) : oMil
      let oTime = ''
      if (type == 1) {
        oMonth = oMonth <= 9 ? '0' + oMonth : oMonth
        oDay = oDay <= 9 ? '0' + oDay : oDay
        oTime = oMonth + '-' + oDay + ' ' + oHour + ':' + oMin
      } else if (type == 2) {
        oTime = oHour + ':' + oMin + ':' + oSen + ':' + oMil
      } else if (type == 3) {
        oTime = oYear + '/' + oMonth + '/' + oDay
      } else if (type == 4) {
        oTime = oYear + '-' + oMonth + '-' + oDay + ' ' + oHour + ':' + oMin + ':' + oSen
      } else if (type == 5) {
        oMonth = oMonth <= 9 ? '0' + oMonth : oMonth
        oDay = oDay <= 9 ? '0' + oDay : oDay
        oTime = '' + oYear + oMonth + oDay + oHour + oMin + oSen + oMil
      } else if (type == 6) {
        oTime = oHour + ':' + oMin + ':' + oSen
      } else {
        oTime = oYear + '/' + oMonth + '/' + oDay + ' ' + oHour + ':' + oMin
      }
      return oTime
    }
  },
  watch: {
    subnums (value) {
      if (typeof value !== 'number') {
        this.subnums = Number(value)
      }
    },
    subscription () {
      this.initData(false)
    }
  }
}
</script>

<style lang="less" scoped>

#manage-sub {
  width: 440px;
  // text-align: center;
  // margin-top: 20vh;
  margin: 0 auto;
  // border: 1px solid #000;
  border-radius: 10px;
  box-sizing: border-box;
  .title {
    margin: 10px 20px 30px;
    color: #252525;
    font-weight: 700;
    line-height: 42px;
    border-bottom: 2px solid #dbdbdb;
  }
  .manage-con {
    height: 460px;
    position: relative;
    .card-wrap {
      width: 400px;
      height: 160px;
      background: linear-gradient(98.41deg, #FFF6D7 0%, #E6AE59 100%);
      border-radius: 16px;
      margin: 0 auto;
      text-align: left;
      padding-top: 20px;
      position: relative;
      overflow: hidden;
      .sub-name {
        font-size: 32px;
        font-weight: bold;
      }
      .cancle-sub {
        height: 18px;
        line-height: 18px;
        border: 1px solid #fff;
        border-radius: 5px;
        padding: 5px;
        font-size: 12px;
        color: #fff;
        cursor: pointer;
      }
      .card-top {
        height: 50%;
        margin: 0 20px;
        display: flex;
        justify-content: space-between;
      }
      .sub-date {
        height: 32px;
        line-height: 32px;
        margin: 5px 0 0 20px;
        font-size: 14px;
        color: #EC5050;
      }
      .manage-pay {
        position: absolute;
        bottom: 0;
        width: calc(100% - 40px);
        height: 38px;
        background: rgba(0, 0, 0, 0.3);
        padding: 0 20px;
        line-height: 38px;
        color: #fff;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        .icon {
          font-size: 20px;
        }
      }
    }

    .edit-plan {
      display: flex;
      // margin-top: 20px;
      margin: 20px;
      align-items: center;
      justify-content: space-between;
      .edit-left {
        margin-left:15px;
        text-align: left;
        width: 60%;
        .plan-total {
          font-weight: 600;
          color: var(--text-color-01);
        }
        .plan-price {
          font-size: 12px;
          color: #999;
        }
      }
      .edit-right {
        // width: 130px;
        text-align: right;
        .current {
          color: var(--text-color-01);
          font-weight: 500;
        }
        .next {
          font-size: 12px;
          line-height: 14px;
          color: #999999;
        }
        .tools {
          font-size: 20px;
          margin: 0 5px;
          cursor: pointer;
        }
        .add {
          color: #33AB4F;
        }
        .limit {
          color: #DBDBDB;
        }
      }
    }

    .card-footer {
      margin: 120px 0 20px;
      display: flex;
      justify-content: flex-end;
      position: absolute;
      bottom: 0;
      right: 0;
      .tools-box {
        padding: 5px 5px;
        border: 1px solid #dbdbdb;
        width: 70px;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;
        font-size: 14px;
      }
      /deep/ .el-button {
        background: #fff0;
        color: #2c3e50;
        width: fit-content;
        border: 1px solid #dbdbdb;
        color: var(--table-button-text-color);
        border-color: var(--table-button-border-color);
        background-color: var(--table-button-bg);
      }
      .confirm-box {
        background: #33AB4F;
        color: #FFFFFF;
      }
    }

    .next-diff {
      text-align: left;
      word-break: break-word;
      margin: 10px 20px;
      padding-left: 15px;
    }
  }

  /deep/ .el-input{
    input::-webkit-inner-spin-button,
    input::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .el-dialog__body {
    .info {
      word-break: break-word;
    }
  }
  // /deep/ .cancle-dialog {
  //   border-radius: 10px;
  //   .el-dialog__footer {
  //     .el-button {
  //       padding: 5px 10px 10px;
  //     }
  //     .el-button--primary {
  //       background: #33AB4F;
  //     }
  //     .el-dialog__body {

  //     }

  //   }
  // }

  // .warning {
  //   color: #EC5050;
  // }
}
/deep/ .free-dialog {
  text-align: center;
  border-radius: 10px;
  .info {
    word-break: break-word;
  }
}
</style>
<style lang="less">
.total-warn {
  font-size: 12px;
  .el-message-box__message {
    font-size: 14px;
    color: #666;
    padding: 0 15px !important;
    word-break: break-word;
  }
  .el-message-box__btns {
    .el-button--primary {
      background-color: #33AB4F;
      border-color: #33AB4F;
    }
  }
  .el-message-box__status.el-icon-warning {
    position: absolute;
    top: -28px;
    color: #FFB524;
  }
  .el-message-box__title {
    padding-left: 36px;
  }
}
</style>
